exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".divFilterSDocDesc[data-v-619cce72]{position:absolute;background-color:#fee3e8;min-height:80px;max-height:170px;z-index:99999;padding:5px;border-radius:5px;box-shadow:0 0 5px rgb(0 0 0/40%)}.divFilterSDocDesc table[data-v-619cce72]{background-color:#fff}.selRow[data-v-619cce72]{background-color:#fbff94}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-619cce72","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/AdminPanel/Components/NewAccDoc/Components/FilterSDocDesc.vue
// module id = 521
// module chunks = 0